import { Box, Paper, Typography } from '@mui/material'

export default function MobileEmptyStateCard({
  icon,
  title = 'No hay resultados',
  description = '',
  sx: sxProp
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        borderRadius: 3,
        border: '1px dashed rgba(89, 127, 169, 0.28)',
        bgcolor: '#FAFCFF',
        px: 2,
        py: 3.25,
        textAlign: 'center',
        boxShadow: '0 10px 24px rgba(89, 127, 169, 0.08)',
        ...(sxProp || {})
      }}
    >
      {icon ? (
        <Box
          sx={{
            width: 52,
            height: 52,
            mx: 'auto',
            mb: 1.5,
            borderRadius: '50%',
            display: 'grid',
            placeItems: 'center',
            bgcolor: 'rgba(89, 127, 169, 0.12)',
            color: '#597FA9'
          }}
        >
          {icon}
        </Box>
      ) : null}
      <Typography sx={{ color: '#203145', fontSize: 16, fontWeight: 700 }}>
        {title}
      </Typography>
      {description ? (
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{
            mt: 0.75,
            mx: 'auto',
            maxWidth: 280,
            lineHeight: 1.5
          }}
        >
          {description}
        </Typography>
      ) : null}
    </Paper>
  )
}
